<template>
  <section class="login">
    <router-link
      v-if="!isLogin"
      :to="{ name: 'login' }"
      class="login__link"
      aria-label="登入會員"
      title="[跳轉頁面]登入會員"
    >
      <img :src="loginSvg" alt="" class="login__icon" />
      <p>登入</p>
    </router-link>

    <div
      v-if="isLogin"
      @click="logout"
      class="login__link login__logout"
      aria-label="登出"
      title="[跳轉頁面]登出"
    >
      <img :src="loginSvg" alt="" class="login__icon" />
      <p>登出</p>
    </div>
  </section>
</template>

<script>
import loginSvg from '@/assets/images/navbar/login.svg';

export default {
  name: 'NavigationLogin',
  props: {},
  data() {
    return {};
  },
  created() {
    const isLogin = window.$cookies.get('templeFrontStageApiToken')
      ? true
      : false;

    if (isLogin) {
      this.$store.commit('setLoginStatus', isLogin);
    }
  },
  computed: {
    loginSvg() {
      return loginSvg;
    },
    isLogin() {
      return this.$store.getters.getLoginStatus;
    },
  },
  methods: {
    logout() {
      window.alert('已登出，重新跳轉頁面');
      this.$store.dispatch('logout');
      this.$router.push({ path: '/' });
    },
  },
  components: {},
};
</script>

<style lang="scss" scoped>
.login {
  padding-top: 4px;
  display: none;

  @include for-desktop {
    display: block;
  }

  @include for-tablet-horizontal {
    display: none;
  }

  &__logout {
    cursor: pointer;
  }
  &__link {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    height: 95%;
    padding: 0 14px;

    > p {
      padding-left: 10px;
      margin: 0;
      display: none;

      @include for-tablet {
        display: block;
      }
    }
  }
  &__icon {
    width: 20px;

    @include for-tablet {
      width: 26px;
    }
  }
}
</style>
